import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function ExpenseAnalyticsPage() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/expense', { replace: true }); }, [navigate]);
  return null;
}
